/**
 * 共通ストアのラッパー
 * 独立化時はここを packages/shared/store に差し替える
 */
export { useAuthStore } from '@/lib/stores/auth'
